// src/components/ui/TextAreaField.jsx
import React, { useState } from 'react';

const ErrorIcon = () => (
  <svg
    className="w-3.5 h-3.5 flex-shrink-0"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

const TextAreaField = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  icon,
  maxLength = 200,
  minLength = 20,
  required = false,
  error = '',
  rows = 4,
  dir = 'rtl',
  characterCountText = 'תווים',
  showLiveHint = true,
}) => {
  const [focused, setFocused] = useState(false);
  const length = (value || '').length;
  const tooShort = length > 0 && length < minLength;

  return (
    <div>
      <label
        htmlFor={name}
        className={`block text-sm font-medium mb-1.5 transition-colors duration-150 ${
          focused ? 'text-indigo-600' : 'text-gray-700'
        }`}
      >
        {icon && <span className="inline-flex ml-1.5 text-gray-400">{icon}</span>}
        {label} {required && <span className="text-red-500">*</span>}
      </label>

      <textarea
        id={name}
        name={name}
        value={value || ''}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={(e) => {
          setFocused(false);
          onBlur?.(e);
        }}
        placeholder={placeholder}
        dir={dir}
        rows={rows}
        maxLength={maxLength}
        className={`w-full px-4 py-2.5 sm:py-3 text-base sm:text-sm border rounded-xl bg-white outline-none resize-none transition-all duration-150 ${
          error
            ? 'border-red-400 bg-red-50 focus:ring-2 focus:ring-red-200'
            : focused
            ? 'border-indigo-400 shadow-sm shadow-indigo-100 focus:ring-2 focus:ring-indigo-100'
            : 'border-gray-200 hover:border-gray-300'
        }`}
      />

      <div className="flex items-start justify-between mt-1.5 gap-2">
        <div className="flex-1 min-w-0">
          {error ? (
            <p className="flex items-center gap-1 text-xs text-red-500">
              <ErrorIcon />
              {error}
            </p>
          ) : showLiveHint && tooShort ? (
            <p className="text-xs text-amber-500">מינימום {minLength} תווים</p>
          ) : showLiveHint ? (
            <p className="text-xs text-gray-400">מקסימום {maxLength} {characterCountText}</p>
          ) : null}
        </div>

        <p
          className={`text-xs flex-shrink-0 tabular-nums ${
            length >= maxLength
              ? 'text-red-400'
              : showLiveHint && tooShort
              ? 'text-amber-500'
              : 'text-gray-400'
          }`}
        >
          {length} / {maxLength}
        </p>
      </div>
    </div>
  );
};

export default TextAreaField;